import * as Yup from 'yup';
import { getRequiredText } from '../../../../global/helpers/transformer';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { InstitutionProps } from '../../models/arc-epi-props';

export interface InstitutionRemoveRequest {
	closing_date?: string;
	comments?: string;
}

export function GetInstitutionRemoveRequestValidationSchema(labelSettings: LabelSettingProps, institutionSettings: InstitutionProps) {

	const validationSchema = Yup.object().shape({
		closing_date: Yup.date().nullable().required(getRequiredText(labelSettings.requiredFormat, institutionSettings.institutionAddRequestRelationshipStartDateLabel)),
		comments: Yup.string().nullable().required(getRequiredText(labelSettings?.requiredFormat, institutionSettings.commentText)),
	});

	return validationSchema;
}
